<template>
  <div class="infobox" :style="{
    width: `${width}px`
  }"
  ref="box">
  <div class="headerBox">
    <div :class="maskImage?'resticon':'word4icon'"><div></div></div>
    {{label}}
    <button class="closeBtn" @click="$emit('close')"><iconClose :width="30" :height="30" color="#FFFFFF" backgroundColor="none"/></button>
    <button class="printBtn" v-show="printBtn" @click="$emit('printInfo')">列印</button>
  </div>
  <div :style="{width: 'calc(100%)'}">
    <slot/>
  </div>
  </div>
</template>

<script>
import iconClose from '../SVG/iconClose'
export default {
  name: 'infobox',
  props: ['show', 'width', 'label', 'printBtn', 'defaultClass', 'maskImage'],
  components: {
    iconClose
  },
  created () {
    this.$nextTick(() => {
      if (this.show) {
        this.$refs.box.classList.add(this.defaultClass)
      }
    })
  },
  watch: {
    show () {
      if (this.show) {
        this.$refs.box.classList.remove('slide-out')
        this.$refs.box.classList.add('slide-in')
      } else {
        this.$refs.box.classList.remove('slide-in')
        this.$refs.box.classList.add('slide-out')
      }
    }
  }
}
</script>

<style lang="scss">
.infobox > div:not(.headerBox) > div:not(.editBox) {
    height: auto;
    display: grid;
    gap: 20px;
}
</style>
<style lang="scss" scoped>
.word4icon {
  width: 70px;
  height: 70px;
  // background-color: #FFFFFF;
  background-position: center;
  background-color: var(--color-base0);
  background-repeat: no-repeat;
  background-size: 43px;
  box-sizing: border-box;
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  &>div{
    width: 64px;
    height: 64px;
    mask-image: url(./svg/icon/user.svg);
    background-color: #FFFFFF;
    mask-size: 38px;
    mask-repeat: no-repeat;
    mask-position: center;
  }
}
.resticon {
  width: 70px;
  height: 70px;
  background-color: #FFFFFF;
  mask-image: url(./booking2.svg);
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.infobox {
  background-color: #FFFFFF;
}
.headerBox {
  width: 100%;
  height: 95px;
  background-color: var(--color-pri);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 27px;
  box-sizing: border-box;
  position: relative;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;

  color: #FFFFFF;
  gap: 14px;
}
.closeBtn {
  position: absolute;
  top: 13px;
  right: 17px;
  background-color: transparent;
  border: none;
  z-index: 91;
  width: 30px;
  height: 31px;
}
.printBtn {
  position: absolute;
  top: 53px;
  right: 17px;
  border: none;
  z-index: 91;
  width: 60px;
  height: 30px;
  background-color: var(--color-pri-letter);
  color: var(--color-pri);
  border-radius: 15px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1em;
}
.infobox {
  &::before {
    display: none!important;
  }
  padding: 0!important;
  margin: 0!important;
  height: 100vh!important;
  min-width: 481px;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #FFFFFF;
  z-index: 91;
  transform: translateX(100%);
  box-shadow: -4px 0px 15px rgba(0, 0, 0, 0.25);
  &>div:not(.headerBox) {
    overflow-x: hidden;
    margin: 0!important;
    position: relative;
    width: calc(100% - 54px);
    height: calc(100% - 110px);
    background-color: #FFFFFF;
    margin-right: 10px;
    padding-right: 16px;
    padding-left: 29px;
    padding-block: 4px;
    overflow-y: auto;
    display: block;
    flex-direction: column;
    gap: 20px;
    &>div {
      height: auto;
      display: grid;
      margin-block: 20px;
    }
    &::-webkit-scrollbar {
      height: 7px;
      width: 7px;
      background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      box-shadow: inset 0 0 6px #0000004d;
      background-color: var(--color-pri);
    }
    &::-webkit-scrollbar-track {
      border: none;
      border-radius: 20px;
      background-color: #d8d8d8;
      border: 2px solid #FFFFFF!important;
    }
  }
}

.slide-in {
    animation: slide-in 0.5s forwards;
    -webkit-animation: slide-in 0.5s forwards;
}

.slide-out {
    animation: slide-out 0.5s forwards;
    -webkit-animation: slide-out 0.5s forwards;
}

@keyframes slide-in {
    100% { transform: translateX(0%); }
}

@-webkit-keyframes slide-in {
    100% { -webkit-transform: translateX(0%); }
}

@keyframes slide-out {
    0% { transform: translateX(0%); }
    100% { transform: translateX(calc(100% + 15px));  }
}

@-webkit-keyframes slide-out {
    0% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(calc(100% + 15px)); }
}
</style>
